import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PARAM = 'showChat';

export function useViewChatSidebar() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const showChat = searchParams.get(PARAM) === 'true';

  const setShowChat = useCallback(
    async (show: boolean) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (show) {
        newSearchParams.set(PARAM, 'true');
      } else {
        newSearchParams.delete(PARAM);
      }
      await navigate({ search: newSearchParams.toString() }, { replace: true });
    },
    [navigate, searchParams],
  );

  return { showChat, setShowChat };
}
